import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from '../../../../shared/common.service';
import { DirectorremunerationService } from './Service/directorremuneration.service';
import * as CryptoJS from 'crypto-js';
import Swal from 'sweetalert2';
import { Observable } from 'rxjs';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';


@Component({
  selector: 'app-directorremuneration',
  templateUrl: './directorremuneration.component.html',
  styleUrls: ['./directorremuneration.component.scss'],
})
export class DirectorremunerationComponent implements OnInit {

  DirectorsFormGroup: FormGroup;
  isJump: any;
  NormalRoutng: boolean;
  showBubbledata: any;
  directorsid: any;
  constructor(public FormBulder: FormBuilder, public DirectorremunerationService: DirectorremunerationService, public Router: Router, public commonService: CommonService, private sidenav: SideNavService) {

  }
  ngOnInit(): void {
    debugger;
    this.commonService.getIncomeStatementsHeaders();
    this.isJump = localStorage.getItem('isJump');
    this.Directorsform();
    this.GetDirectorremuneration();
      this.commonService.getNotesData();
      this.clearfield();
    this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), this.DirectorsFormGroup.controls['APPeriodId'].value).subscribe((data) => {
      this.commonService.showBubble = data[0].ImportStatus
      if (this.commonService.showBubble) {
        this.sidenav.setShowBubble(true)
        this.GetDirectorremuneration_LY()
      }
    })

    if (localStorage.getItem("SubmitStatus") == "true")
      this.DirectorsFormGroup.disable()
  }
  Directorsform() {
    this.DirectorsFormGroup = this.FormBulder.group({
      DirectorsRemunerationId: new FormControl(),
      MasterId: new FormControl(),
      DirectorRemuneration: new FormControl(),
      DirectorRemuneration_LY: new FormControl(),
      CompanyContributionsToDefinedBenefitPlansDirectors: new FormControl(),
      CompanyContributionsToDefinedBenefitPlansDirectors_LY: new FormControl(),
      DirectorRemunerationBenefitsIncludingPaymentsToThirdParties: new FormControl({ value: "", disabled: true }),
      DirectorRemunerationBenefitsIncludingPaymentsToThirdParties_LY: new FormControl({ value: "", disabled: true }),
      DirectorsRemunerationFreeøtextComment: new FormControl(),
      APPeriodId: new FormControl(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)),
      CreatedBy: new FormControl(localStorage.getItem('LoginuserId')),
      CreatedDate: new FormControl(),
      ModifiedBy: new FormControl(),
      ModifiedDate: new FormControl(),

    })
  }

  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        this.DirectorsFormGroup.reset()
      }
    })
  }

  GetDirectorremuneration() {
    debugger; 
    this.DirectorremunerationService.GetOneDirectorremuneration(this.DirectorsFormGroup.controls['APPeriodId'].value ).subscribe((data:any) => {
      this.DirectorsFormGroup.patchValue(data);
      this.directorsid = data.DirectorsRemunerationId
      this.DirectorsFormGroup.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));

    })
  }
  GetDirectorremuneration_LY() {
    debugger; 
    this.DirectorremunerationService.GetOneDirectorremuneration_LY(this.DirectorsFormGroup.controls['APPeriodId'].value ).subscribe(data => {
      this.showBubbledata =data;
      this.DirectorsFormGroup.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));

    })
  }

  Save_Next() {
    debugger;
    if (this.directorsid != null && this.directorsid != "")
      this.DirectorsFormGroup.controls["DirectorsRemunerationId"].setValue(this.directorsid);
    this.DirectorremunerationService.SaveDirectorremuneration(this.DirectorsFormGroup.getRawValue()).subscribe(data => {
      this.DirectorsFormGroup.markAsPristine()
      if(this.NormalRoutng)
      return false;
      var nextPage;
      nextPage = this.commonService.getNextNoteSelection("Directors remuneration", this.commonService.NotesList)
      if (this.isJump == 'true')
        this.Router.navigate(['/notes'])
      else if (nextPage == 'directorsremuneration') {
        nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
        this.Router.navigate([nextPage]);
      }
      else {
        this.Router.navigate([nextPage]);
      }
    })
    // this.Router.navigate(['/employees']);
  }
  On_Back() {
    debugger;
    this.DirectorsFormGroup.markAsPristine()
    var backpage;
    if (this.isJump == 'true')
      this.Router.navigate(['/notes'])
    else {
      backpage = this.commonService.getBackSelection("Directors remuneration", this.commonService.NotesList)
      this.Router.navigate([backpage]);
    }
  }
  Calculations() {
    debugger;
    var total1 = +this.DirectorsFormGroup.controls['DirectorRemuneration'].value + +this.DirectorsFormGroup.controls['CompanyContributionsToDefinedBenefitPlansDirectors'].value;
    var total2 = +this.DirectorsFormGroup.controls['DirectorRemuneration_LY'].value + +this.DirectorsFormGroup.controls['CompanyContributionsToDefinedBenefitPlansDirectors_LY'].value;
    this.DirectorsFormGroup.controls['DirectorRemunerationBenefitsIncludingPaymentsToThirdParties'].setValue(total1 == 0 ? '' : total1);
    this.DirectorsFormGroup.controls['DirectorRemunerationBenefitsIncludingPaymentsToThirdParties_LY'].setValue(total2 == 0 ? '' : total2);


  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.DirectorsFormGroup.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight:900'>You have unsaved data.</span> <br><span>Do you want to save your changes before leaving?</span>",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.NormalRoutng = true;
          this.Save_Next();
          return true;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.Router.navigate(['/business']);

  }

}
